import { GPUInstanceType } from "types/InstanceTypes";
import {
  formatMemoryForDisplay,
  parseMemoryToGiB,
} from "components/Environment/Create/utils";

export interface GPUVariant {
  key: string;
  gpuCounts: number[];
  memoryGiB: number;
  memoryLabel: string;
  instances: GPUInstanceType[];
}

const getNormalizedMemoryGiB = (instance: GPUInstanceType): number =>
  parseMemoryToGiB(instance.supported_gpus?.[0]?.memory ?? "0");

export const getGPUVariantKey = (instance: GPUInstanceType): string => {
  const gpu = instance.supported_gpus?.[0];
  if (!gpu) return "";

  return getNormalizedMemoryGiB(instance).toFixed(6);
};

/** Groups provider SKUs by per-GPU memory. */
export const groupInstancesByGPUVariant = (
  instances: GPUInstanceType[],
): GPUVariant[] => {
  const variants = new Map<string, GPUVariant>();

  instances.forEach((instance) => {
    const gpu = instance.supported_gpus?.[0];
    if (!gpu) return;

    const key = getGPUVariantKey(instance);
    const existing = variants.get(key);
    if (existing) {
      existing.instances.push(instance);
      if (!existing.gpuCounts.includes(gpu.count)) {
        existing.gpuCounts.push(gpu.count);
        existing.gpuCounts.sort((a, b) => a - b);
      }
      return;
    }

    variants.set(key, {
      key,
      gpuCounts: [gpu.count],
      memoryGiB: getNormalizedMemoryGiB(instance),
      memoryLabel: formatMemoryForDisplay(gpu.memory),
      instances: [instance],
    });
  });

  return Array.from(variants.values()).sort(
    (a, b) => a.memoryGiB - b.memoryGiB,
  );
};
